<script setup>
const gsapTimeline = useGsapTimeline()
defineProps({
  text: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['timeline'])

const mainElement = ref(null)
const mainBack1Element = ref(null)
const mainBack2Element = ref(null)
const outline1Element = ref(null)
const outline2Element = ref(null)

onMounted(() => {
  const timeline = gsapTimeline()
    .set([outline1Element, mainBack1Element, mainBack2Element, mainElement, outline2Element], { visibility: 'inherit' })
    .to(outline1Element, { x: -425, letterSpacing: 0, duration: 0.32, ease: 'power2.inOut' })
    .to(mainBack1Element, { letterSpacing: 0, duration: 0.32, ease: 'power2.out' }, '<')
    .to(mainBack2Element, { letterSpacing: 0, duration: 0.32, ease: 'power2.out' }, '<')
    .to(mainElement, { letterSpacing: 0, duration: 0.32, ease: 'power2.out' }, '<')
    .to(outline2Element, { x: 300, letterSpacing: 0, duration: 0.32, ease: 'power2.inOut' }, '<')
    .set([outline1Element, mainBack1Element, mainBack2Element, mainElement, outline2Element], { visibility: 'hidden' })

  emit('timeline', timeline)
})
</script>

<template>
  <div
    ref="outline1Element"
    class="invisible absolute z-50 top-3 left-[1000px] tracking-[100px] text-transparent text-[407px] font-semibold text-stroke-5 text-stroke-white whitespace-nowrap"
    v-text="text"
  />
  <div
    ref="mainBack1Element"
    class="invisible absolute z-50 top-[350px] left-[-999999px] right-[-999999px] tracking-[160px] text-center text-white text-[407px] font-semibold whitespace-nowrap"
    v-text="text"
  />
  <div
    ref="mainBack2Element"
    class="invisible absolute z-50 top-[350px] left-[-999999px] right-[-999999px] tracking-[150px] text-center text-white text-[407px] font-semibold whitespace-nowrap"
    v-text="text"
  />
  <div
    ref="mainElement"
    class="invisible absolute z-50 top-[350px] left-[-999999px] right-[-999999px] tracking-[125px] text-center text-q-cr-red-primary text-[407px] font-semibold whitespace-nowrap"
    v-text="text"
  />
  <div
    ref="outline2Element"
    class="invisible absolute z-50 -bottom-6 right-[550px] tracking-[100px] text-transparent text-[407px] font-semibold text-stroke-5 text-stroke-white whitespace-nowrap"
    v-text="text"
  />
</template>
